import { useEffect, useState } from 'react';
import { supabaseClient } from '../config/supabase';

export default function useModuleAccess(module, action = 'view', entityId = null, groupId = null) {
    const [state, setState] = useState({ allowed: false, loading: Boolean(module) });

    useEffect(() => {
        let active = true;
        if (!module) {
            setState({ allowed: true, loading: false });
            return () => { active = false; };
        }
        setState({ allowed: false, loading: true });
        const params = {
            p_module: module,
            p_action: action,
            p_entity_id: entityId
        };
        if (groupId) params.p_group_id = groupId;
        const rpc = entityId || groupId ? 'has_module_access' : 'bl395a_area_access';
        const rpcParams = entityId || groupId ? params : { p_module: module, p_action: action };
        supabaseClient.rpc(rpc, rpcParams).then(({ data, error }) => {
            if (active) setState({ allowed: !error && data === true, loading: false });
        });
        return () => { active = false; };
    }, [module, action, entityId, groupId]);

    return state;
}
